import { createAction, props } from '@ngrx/store';
import { Portals } from '@qwyk/models';

export const init = createAction(
    '[ProofOfDelivery Page] Init',
    props<{ parent: Portals.ParentEntity }>()
);

export const loadProofOfDeliverySuccess = createAction(
    '[ProofOfDelivery/API] Load ProofOfDelivery Success',
    props<{ proofOfDelivery: Portals.ProofOfDelivery | null }>()
);

export const loadProofOfDeliveryFailure = createAction(
    '[ProofOfDelivery/API] Load ProofOfDelivery Failure',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props<{ error: any }>()
);

export const reset = createAction('[ProofOfDelivery/API] reset');
